import { z } from 'zod';
import { TENANT_PROVIDER_CHANNELS } from './communication-channel.registry.js';

export const COMMUNICATION_CHANNELS = TENANT_PROVIDER_CHANNELS;

export const SMS_PROVIDER_TYPES = [
    'netgsm',
    'iletimerkezi',
    'mutlucell',
    'vatansms',
    'verimor',
    'turkcell',
    'generic-http',
];

export const EMAIL_PROVIDER_TYPES = ['smtp', 'resend', 'sendgrid', 'ses', 'office365-oauth2'];

const CommunicationProviderBaseSchema = z.object({
    id: z.string().optional(),
    name: z.string().trim().optional(),
    channel: z.enum(COMMUNICATION_CHANNELS, {
        errorMap: () => ({ message: 'form.validation.channelRequired' }),
    }),
    providerType: z.string().min(1, { message: 'form.validation.providerTypeRequired' }),
    /** Plaintext on write; masked on read. */
    credentials: z.record(z.string()).optional().default({}),
    from: z.string().trim().optional(),
    config: z.record(z.unknown()).optional().default({}),
    isActive: z.boolean().optional().default(true),
    isDefault: z.boolean().optional().default(false),
    priority: z.number().int().optional().default(100),
    status: z.enum(['active', 'inactive']).optional().default('active'),
    customFields: z.record(z.unknown()).optional(),
});

/** providerType must belong to the selected channel. */
function refineProviderType(schema) {
    return schema.superRefine((value, ctx) => {
        const valid = value.channel === 'sms' ? SMS_PROVIDER_TYPES : EMAIL_PROVIDER_TYPES;
        if (value.providerType && !valid.includes(value.providerType)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['providerType'],
                message: 'form.validation.providerTypeChannelMismatch',
            });
        }
    });
}

export const CommunicationProviderSchema = CommunicationProviderBaseSchema;
export const CreateCommunicationProviderSchema = refineProviderType(
    CommunicationProviderBaseSchema.omit({ id: true })
);
export const UpdateCommunicationProviderSchema = refineProviderType(
    CommunicationProviderBaseSchema.partial().superRefine((value, ctx) => {
        if (value.channel && value.providerType) {
            const valid = value.channel === 'sms' ? SMS_PROVIDER_TYPES : EMAIL_PROVIDER_TYPES;
            if (!valid.includes(value.providerType)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: ['providerType'],
                    message: 'form.validation.providerTypeChannelMismatch',
                });
            }
        }
    })
);
export const CommunicationProviderFormSchema = CommunicationProviderBaseSchema;
